/**
 * Tab-local "SPA session was established" latch for cookie V2 customer auth.
 *
 * Cookie mode keeps getToken null; when the access httpOnly cookie expires,
 * APIs return missing customer session credential. Anonymous cold-boot must
 * still skip refresh thrash, but an established SPA session (memory customerId
 * after hydrate/establish) must attempt POST …/customer-auth/refresh.
 *
 * CustomerSessionProvider marks this when a session is present and clears on wipe.
 * BAN gating on Bearer / tokenStorage — cookie jar only.
 */

let sessionEstablished = false;

export function markCustomerSessionEstablished(): void {
  sessionEstablished = true;
}

export function clearCustomerSessionEstablished(): void {
  sessionEstablished = false;
}

export function isCustomerSessionEstablished(): boolean {
  return sessionEstablished;
}

/** Test-only reset. */
export function resetCustomerSessionEstablishedLatchForTests(): void {
  sessionEstablished = false;
}
